module.exports = __webpack_public_path__ + "img/Logo-clube-hd.29335781.png";